import React from "react";
import { useLanguage } from '../../components/hooks/LanguageContext'; // <-- хук

const HowItWorksSection = ({ url }) => {
    const { language } = useLanguage(); // текущий язык

    const textContent = {
        ru: {
            title: "Как это работает",
            subtitle: "Все очень просто: выберите местоположение, получите данные и отчеты, принимайте обоснованные решения.",
            steps: [
                {
                    number: "1",
                    title: "Выберите местоположение",
                    text: "Укажите точку на карте, для которой хотите получить анализ проходимости и доходности. Вы можете выбрать точку и настроить радиус вокруг нее, который вас интересует."
                },
                {
                    number: "2",
                    title: "Выберите глубину анализа",
                    text: "Вы можете получить удобную выгрузку, много важных данных собранных в одном месте, посчитаем за вас ключевые аспекты, которые помогут сделать вам выбор. Или же закажите глубокую аналитику и получите расширенный блок данных, а самое главное — узнаете сколько вы заработаете в этой точке."
                },
                {
                    number: "3",
                    title: "Примите взвешенное решение",
                    text: "Ознакомьтесь с собранной информацией о локации и аналитикой по ней. Используйте полученные данные для принятия обоснованного решения о размещении бизнеса."
                }
            ]
        },
        en: {
            title: "How It Works",
            subtitle: "It’s very simple: choose a location, get data and reports, make informed decisions.",
            steps: [
                {
                    number: "1",
                    title: "Choose a location",
                    text: "Select a point on the map for which you want to get footfall and profitability analysis. You can select a point and adjust the radius around it."
                },
                {
                    number: "2",
                    title: "Select depth of analysis",
                    text: "Receive a convenient data export, many important data collected in one place, we calculate key aspects for you to make a decision. Or order advanced analytics and get an extended data set, plus discover how much you will earn at this location."
                },
                {
                    number: "3",
                    title: "Make an informed decision",
                    text: "Review the collected information about the location and analytics. Use the data to make a well-informed decision about where to place your business."
                }
            ]
        }
    };

    const t = textContent[language];

    return (
        <section data-bs-version="5.1" className="features20 cid-uHqHMmSvwu" id={url}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12 col-lg-9">
                        <div className="card-wrapper pb-4">
                            <div className="card-box align-center">
                                <h4 className="card-title mbr-fonts-style mb-4 display-2">
                                    <strong>{t.title}</strong>
                                </h4>
                                <p className="mbr-text mbr-fonts-style mb-4 display-7">
                                    {t.subtitle}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-8">
                        {t.steps.map((step, index) => (
                            <div
                                className={`item mbr-flex ${index === t.steps.length - 1 ? "last" : ""}`}
                                key={index}
                            >
                                <div className="icon-box">
                                    <span className="step-number mbr-fonts-style display-5">{step.number}</span>
                                </div>
                                <div className="text-box">
                                    <h4 className="icon-title card-title mbr-black mbr-fonts-style display-7">
                                        <strong>{step.title}</strong>
                                    </h4>
                                    <h5 className="icon-text mbr-black mbr-fonts-style display-4">
                                        {step.text}
                                    </h5>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowItWorksSection;
